export interface CountrySalaryConfig {
  currency: string;
  iconClass: string;
  isSalaryRequired: boolean;
  minSalaryLabelKey: string;
  maxSalaryLabelKey: string;
}

type CountryValue = string | { name?: string; code?: string; country?: string; label?: string; value?: string } | null | undefined;

const DEFAULT_SALARY_CONFIG: CountrySalaryConfig = {
  currency: 'USD',
  iconClass: 'app-ico app-ico__salary',
  isSalaryRequired: false,
  minSalaryLabelKey: 'PositionCreate.MinSalary',
  maxSalaryLabelKey: 'PositionCreate.MaxSalary'
};

const INDIA_SALARY_CONFIG: CountrySalaryConfig = {
  currency: 'INR',
  iconClass: 'app-ico app-ico__salary-inr',
  isSalaryRequired: true,
  minSalaryLabelKey: 'PositionCreate.MinSalaryLpa',
  maxSalaryLabelKey: 'PositionCreate.MaxSalaryLpa'
};

const COUNTRY_SALARY_CONFIG: Record<string, CountrySalaryConfig> = {
  india: INDIA_SALARY_CONFIG,
  in: INDIA_SALARY_CONFIG
};

export function getCountrySalaryConfig(country: CountryValue, fallbackCurrency?: string | null): CountrySalaryConfig {
  const normalizedCountry = normalizeCountry(country);
  const countryConfig = normalizedCountry ? COUNTRY_SALARY_CONFIG[normalizedCountry] : null;

  return {
    currency: countryConfig?.currency || fallbackCurrency || DEFAULT_SALARY_CONFIG.currency,
    iconClass: countryConfig?.iconClass || DEFAULT_SALARY_CONFIG.iconClass,
    isSalaryRequired: countryConfig?.isSalaryRequired ?? DEFAULT_SALARY_CONFIG.isSalaryRequired,
    minSalaryLabelKey: countryConfig?.minSalaryLabelKey || DEFAULT_SALARY_CONFIG.minSalaryLabelKey,
    maxSalaryLabelKey: countryConfig?.maxSalaryLabelKey || DEFAULT_SALARY_CONFIG.maxSalaryLabelKey
  };
}

function normalizeCountry(country: CountryValue): string | null {
  if (!country) {
    return null;
  }

  if (typeof country === 'string') {
    return country.trim().toLowerCase();
  }

 return (country.name || country.code || country.country || '').trim().toLowerCase() || null;
}

